<template>
  <layout-default>
    <div class="text">
      <div class="text__container container">
        <h3>Polityka prywatności serwisu https://polandgroups.pl/shop/</h3>

        <h3>1. Informacje ogólne</h3>

        <p>1. Operatorem Serwisu https://polandgroups.pl/shop/ jest Polandgroups Spółka z ograniczoną odpowiedzialnością z siedzibą w Warszawie, ul. Aleja Krakowska 121 02-180 Warszawa, wpisaną w Rejestrze Przedsiębiorców Krajowego Rejestru Sądowego prowadzonym przez Sąd Rejonowy KRS 0000618480,  posiadającą numer identyfikacji podatkowej NIP 1132910509 oraz Regon 364474954, który prowadząc działalność gospodarczą dokonuje w ramach Sklepu sprzedaży towarów lub świadczenia usług.</p>

        <p>2. Serwis realizuje funkcje pozyskiwania informacji o użytkownikach i ich zachowaniu w następujący sposób:</p>

        <p>a. Poprzez dobrowolnie wprowadzone w formularzach informacje.</p>

        <p>b. Poprzez zapisywanie w urządzeniach końcowych pliki cookie (tzw. "ciasteczka").</p>

        <p>c. Poprzez gromadzenie logów serwera www przez operatora hostingowego [pełna nazwa operatora], funkcjonującego pod adresem Shop.Polandgroups</p>

        <p> </p>

        <p> </p>

        <h3>2. Informacje w formularzach</h3>

        <p>1. Serwis zbiera informacje podane dobrowolnie przez użytkownika.</p>

        <p>2. Serwis może zapisać ponadto informacje o parametrach połączenia (oznaczenie czasu, adres IP)</p>

        <p>3. Dane w formularzu nie są udostępniane podmiotom trzecim inaczej, niż za zgodą użytkownika.</p>

        <p>4. Dane podane w formularzu mogą stanowić zbiór potencjalnych klientów, zarejestrowany przez Operatora Serwisu w rejestrze prowadzonym przez Generalnego Inspektora Ochrony Danych Osobowych.</p>

        <p>5. Dane podane w formularzu są przetwarzane w celu wynikającym z funkcji konkretnego formularza, np w celu dokonania procesu obsługi zgłoszenia serwisowego lub kontaktu handlowego.</p>

        <p>6. Dane podane w formularzach mogą być przekazane podmiotom technicznie realizującym niektóre usługi – w szczególności dotyczy to przekazywania informacji o posiadaczu rejestrowanej domeny do podmiotów będących operatorami domen internetowych (przede wszystkim Naukowa i Akademicka Sieć Komputerowa j.b.r – NASK), serwisów obsługujących płatności lub też innych podmiotów, z którymi Operator Serwisu w tym zakresie współpracuje.</p>

        <p> </p>

        <h3>3. Informacja o plikach cookies</h3>

        <p>1. Serwis korzysta z plików cookies.</p>

        <p>2. Pliki cookies (tzw. „ciasteczka") stanowią dane informatyczne, w szczególności pliki tekstowe, które przechowywane są w urządzeniu końcowym Użytkownika Serwisu i przeznaczone są do korzystania ze stron internetowych Serwisu. Cookies zazwyczaj zawierają nazwę strony internetowej, z której pochodzą, czas przechowywania ich na urządzeniu końcowym oraz unikalny numer.</p>

        <p>3. Podmiotem zamieszczającym na urządzeniu końcowym Użytkownika Serwisu pliki cookies oraz uzyskującym do nich dostęp jest operator Serwisu.</p>

        <p>4. Pliki cookies wykorzystywane są w następujących celach:</p>

        <p>a. tworzenia statystyk, które pomagają zrozumieć, w jaki sposób Użytkownicy Serwisu korzystają ze stron internetowych, co umożliwia ulepszanie ich struktury i zawartości;</p>

        <p>b. utrzymanie sesji Użytkownika Serwisu (po zalogowaniu), dzięki której Użytkownik nie musi na każdej podstronie Serwisu ponownie wpisywać loginu i hasła;</p>

        <p>c. określania profilu użytkownika w celu wyświetlania mu dopasowanych materiałów w sieciach reklamowych, w szczególności sieci Google.</p>

        <p>5. W ramach Serwisu stosowane są dwa zasadnicze rodzaje plików cookies: „sesyjne" (session cookies) oraz „stałe" (persistent cookies). Cookies „sesyjne" są plikami tymczasowymi, które przechowywane są w urządzeniu końcowym Użytkownika do czasu wylogowania, opuszczenia strony internetowej lub wyłączenia oprogramowania (przeglądarki internetowej). „Stałe" pliki cookies przechowywane są w urządzeniu końcowym Użytkownika przez czas określony w parametrach plików cookies lub do czasu ich usunięcia przez Użytkownika.</p>

        <p>6. Oprogramowanie do przeglądania stron internetowych (przeglądarka internetowa) zazwyczaj domyślnie dopuszcza przechowywanie plików cookies w urządzeniu końcowym Użytkownika. Użytkownicy Serwisu mogą dokonać zmiany ustawień w tym zakresie. Przeglądarka internetowa umożliwia usunięcie plików cookies. Możliwe jest także automatyczne blokowanie plików cookies Szczegółowe informacje na ten temat zawiera pomoc lub dokumentacja przeglądarki internetowej.</p>

        <p>7. Ograniczenia stosowania plików cookies mogą wpłynąć na niektóre funkcjonalności dostępne na stronach internetowych Serwisu.</p>

        <p>8. Pliki cookies zamieszczane w urządzeniu końcowym Użytkownika Serwisu i wykorzystywane mogą być również przez współpracujących z operatorem Serwisu reklamodawców oraz partnerów.</p>

        <p>9. Zalecamy przeczytanie polityki ochrony prywatności tych firm, aby poznać zasady korzystania z plików cookie wykorzystywane w statystykach: Polityka ochrony prywatności Google Analytics</p>

        <p>10. Pliki cookie mogą być wykorzystane przez sieci reklamowe, w szczególności sieć Google, do wyświetlenia reklam dopasowanych do sposobu, w jaki użytkownik korzysta z Serwisu. W tym celu mogą zachować informację o ścieżce nawigacji użytkownika lub czasie pozostawania na danej stronie.</p>

        <p>11. W zakresie informacji o preferencjach użytkownika gromadzonych przez sieć reklamową Google użytkownik może przeglądać i edytować informacje wynikające z plików cookies przy pomocy narzędzia: https://www.google.com/ads/preferences/</p>

        <p> </p>

        <h3>4. Logi serwera</h3>

        <p>1. Informacje o niektórych zachowaniach użytkowników podlegają logowaniu w warstwie serwerowej. Dane te są wykorzystywane wyłącznie w celu administrowania serwisem oraz w celu zapewnienia jak najbardziej sprawnej obsługi świadczonych usług hostingowych.</p>

        <p>2. Przeglądane zasoby identyfikowane są poprzez adresy URL. Ponadto zapisowi mogą podlegać:</p>

        <p>a. Czas nadejścia zapytania,</p>

        <p>b. Czas wysłania odpowiedzi,</p>

        <p>c. Nazwę stacji klienta – identyfikacja realizowana przez protokół HTTP,</p>

        <p>d. Informacje o błędach jakie nastąpiły przy realizacji transakcji HTTP,</p>

        <p>e. Adres URL strony poprzednio odwiedzanej przez użytkownika (referer link) – w przypadku gdy przejście do Serwisu nastąpiło przez odnośnik,</p>

        <p>f. Informacje o przeglądarce użytkownika,</p>

        <p>g.Informacje o adresie IP.</p>

        <p>3. Dane powyższe nie są kojarzone z konkretnymi osobami przeglądającymi strony.</p>

        <p>4. Dane powyższe są wykorzystywane jedynie dla celów administrowania serwerem.</p>

        <p> </p>

        <h3>5. Udostępnienie danych</h3>

        <p>1. Dane podlegają udostępnieniu podmiotom zewnętrznym wyłącznie w granicach prawnie dozwolonych.</p>

        <p>2. Dane umożliwiające identyfikację osoby fizycznej są udostępniane wyłączenie za zgodą tej osoby.</p>

        <p>3. Operator może mieć obowiązek udzielania informacji zebranych przez Serwis upoważnionym organom na podstawie zgodnych z prawem żądań w zakresie wynikającym z żądania.</p>

        <p> </p>

        <p>6. Zarządzanie plikami cookies – jak w praktyce wyrażać i cofać zgodę?</p>

        <p>1. Jeśli użytkownik nie chce otrzymywać plików cookies, może zmienić ustawienia przeglądarki. Zastrzegamy, że wyłączenie obsługi plików cookies niezbędnych dla procesów uwierzytelniania, bezpieczeństwa, utrzymania preferencji użytkownika może utrudnić, a w skrajnych przypadkach może uniemożliwić korzystanie ze stron www</p>

        <p>2. W celu zarządzania ustawieniami cookies wybierz z listy poniżej przeglądarkę internetową/ system i postępuj zgodnie z instrukcjami:</p>

        <p>a. Internet Explorer</p>

        <p>b. Chrome</p>

        <p>c. Safari</p>

        <p>d. Firefox</p>

        <p>e. Opera</p>

        <p>f. Android</p>

        <p>g. Safari (iOS)</p>

        <p>h. Windows Phone</p>

        <p>i. Blackberry</p>
      </div>
    </div>
  </layout-default>
</template>
<script>
import LayoutDefault from '@/layouts/LayoutDefault'
export default {
  components: { LayoutDefault, }
}
</script>